module.exports = __webpack_public_path__ + "static/img/chanping24.0cf1142.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img1/srzq/chanping24.jpg
// module id = e7NW
// module chunks = 0